var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99998 0.133975C7.30938 -0.0446582 7.69058 -0.0446582 7.99998 0.133975L14 3.71132C14.3094 3.88995 14.5 4.22008 14.5 4.57734V11.4226C14.5 11.7799 14.3094 12.11 14 12.2887L7.99998 15.866C7.69058 16.0447 7.30938 16.0447 6.99998 15.866L1 12.2887C0.690599 12.11 0.5 11.7799 0.5 11.4226V4.57734C0.5 4.22008 0.690599 3.88995 1 3.71132L6.99998 0.133975ZM11.287 6.28033C11.571 5.98744 11.571 5.51256 11.287 5.21967C11.003 4.92678 10.5425 4.92678 10.2585 5.21967L6.40909 9.18934L4.74153 7.46967C4.45752 7.17678 3.99703 7.17678 3.71301 7.46967C3.429 7.76256 3.429 8.23744 3.71301 8.53033L5.89483 10.7803C6.03122 10.921 6.21621 11 6.40909 11C6.60197 11 6.78696 10.921 6.92335 10.7803L11.287 6.28033Z",
    fill: "#00A859"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.5e2fcefc3eb15de11e98167f7737b874.svg";
export { ForwardRef as ReactComponent };